const baseHost = process.env.BASE_HOST || '//tripmaza.com',
    dashboardHost = process.env.DASHBOARD_HOST || '//dashboard.tripmaza.com',
    cookieDomain = process.env.COOKIE_DOMAIN || 'tripmaza.com',
    serviceDomain = process.env.SERVICE_DOMAIN || 'tripmaza.com',
    serviceProtocol = process.env.SERVICE_PROTOCOL || 'https',
    baseUrl = process.env.STATIC_BASE_URL || '//static.tripmaza.com',
    afterLogoutPath = process.env.LOGOUT_PATH || '/nav',
    citiesInfoIndex = process.env.CITY_INFO_INDEX || 'tm_cities-info',
    juryKey = process.env.JURY_KEY || 'Siliguri',
    fromEmail = process.env.FROM_EMAIL || 'hotel@tripmaza.com',
    clientName = process.env.CLIENT_NAME || 'tripmaza',
    whitelabelFlag = process.env.WHITELABEL_DISABLED || false,
    clientType = process.env.CLIENT_TYPE || 'b2b',
    redirectionDomains = {
        FLIGHT: `${baseHost}`,
        DASHBOARD: `${dashboardHost}`,
        HOTEL: `${baseHost}/hotel`,
        HOMEPAGE: `${baseHost}`,
        RAIL: `${baseHost}`,
        HOTEL_SERVER: `${baseHost}`
    },
    Config = {
        serverConfig: {
            mock_srv: {
                protocol: `${serviceProtocol}`,
                server: 'demo6750241.mockable.io', //Here you can edit the mock api address
                port: ''
            },
            google_srv: {
                protocol: 'https',
                server: 'maps.googleapis.com',
                port: '',
                proxyUrl: 'https://cors-anywhere.herokuapp.com/'
            },
            static_srv: {
                protocol: `${serviceProtocol}`,
                server: 'static.tripmaza.com',
                port: ''
            },
            xms_srv: {
                protocol: `${serviceProtocol}`,
                server: `${serviceDomain}`,
                port: ''
            },
            rms_srv: {
                protocol: `${serviceProtocol}`,
                server: `${serviceDomain}`,
                port: ''
            },
            fms_srv: {
                protocol: `${serviceProtocol}`,
                server: `${serviceDomain}`,
                port: ''
            },
            hms_srv: {
                protocol: `${serviceProtocol}`,
                server: `${serviceDomain}`,
                port: ''
            },
            ums_srv: {
                protocol: `${serviceProtocol}`,
                server: `${serviceDomain}`,
                port: '',
            },
            gms_srv: {
                protocol: `${serviceProtocol}`,
                server: `${serviceDomain}`,
                port: ''
            },
            pms_srv: {
                protocol: `${serviceProtocol}`,
                server: `${serviceDomain}`,
                port: ''
            },
            oms_srv: {
                protocol: `${serviceProtocol}`,
                server: `${serviceDomain}`,
                port: ''
            }
        },
        redirectionConfig: {
            AGENT: `${redirectionDomains.FLIGHT}/flight/`,
            AGENT_STAFF: `${redirectionDomains.FLIGHT}/flight/`,
            ADMIN: `${redirectionDomains.DASHBOARD}/manage-user`,
            ACCOUNTS: `${redirectionDomains.DASHBOARD}/manage-user`,
            DISTRIBUTOR: `${redirectionDomains.DASHBOARD}/manage-user`,
            DISTRIBUTOR_STAFF: `${redirectionDomains.DASHBOARD}/manage-user`,
            CALLCENTER: `${redirectionDomains.DASHBOARD}/manage-carts`,
            SALES: `${redirectionDomains.DASHBOARD}/manage-user`,
            SUPPLIER: `${redirectionDomains.DASHBOARD}/manage-inventory`,
            SUPPLIER_ADMIN: `${redirectionDomains.DASHBOARD}/manage-inventory`,
            SUPERVISOR: `${redirectionDomains.DASHBOARD}/manage-carts`,
            WHITELABEL_PARTNER: `${redirectionDomains.DASHBOARD}/manage-user`,
            WHITELABEL_STAFF: `${redirectionDomains.DASHBOARD}/manage-user`
        },
        isRelativeUrl: false,
        redirectionDomains: {
            FLIGHT: `${baseHost}`,
            DASHBOARD: `${dashboardHost}`,
            HOTEL: `${baseHost}`,
            HOMEPAGE: `${baseHost}`,
            HOTEL_SERVER: `${baseHost}`
        },
        flightProductUrl: baseHost,
        cookieDomain,
        serviceDomain,
        serviceProtocol,
        baseUrl, afterLogoutPath,
        clientName,
        whitelabelFlag,
        currEnv: 'prod',
        EnableDownloadAsPDF: true,
        EnableSpecialCategory: true,
        EnableSessionTime: true,
        sessionExpireTimeLimit: 58,
        maxRetry: 30,
        pdpRetry: 10,
        backendPdpRetry: false,
        markupAllowConfig: {
            "EXPEDIA": false
        },
        panCardObj: {
            isPANVisible: true, // for pan card and passport to be visible
            supplierList: ['TJDesiya', 'TJTAMTOUR', 'TJclertrip', 'TJLOCAL', 'TJOYO', 'TJTAMARIND', 'TJExpedia', 'TJCLEARTRIP', 'TJagoda', 'AGODA', 'DESIYA', 'EXPEDIA']
        },
        citiesInfoIndex,
        emailData: "support@tripmaza.com",
        contact: "810 101 1011",
        companyName: 'Shree Travels',
        year: '2020',
        staticFooter: true,
        searchBoxHeading: "Book cheapest Hotels.",
        defaultLogo: '//static.tripmaza.com/img/logotm.png',
        searchbox_V2: false, // second design for searchbox,
        juryKey,
        fromEmail,
        defaultRole: 'CUSTOMER',
        clientType,
        showVoucherCode: false,
        payfeeText: 'Payment Fee',
        b2c: {
            showVoucherCode: true,
            showFlightMobile: true,
            showHotelMobile: true,
            enablePointsAndCoins: false,
            onloadPopupConfig: {
                showOnloadPopup: true,
                frequency: 86400,
                displayOnLogin: true
            },
            showAddToQuote: false,
            showPerNightPrice: false,
            editMarkup: false,
            searchByLocationFilter: false,
            holdAllowed: false,
            fetchTripAdvisor: false,
            afterLogoutPath: '/hotel',
            defaultRatings: '1,2,3,4,5',
            EnableSpecialCategory: false,

            autoFillPaxMobile: false,
            autoFillPaxEmail: false,
            payfeeText: 'Convenience Fee',
            salesConfirmationMail: {
                'TJLOCAL': []
            },
            scripts: {
                zoho: '<script src="https://cdn.pagesense.io/js/tripmaza/57b1cf7fe89a4064a18a90045463bd8f.js"></script>',
                salesIq: `<script type="text/javascript" id="zsiqchat">
                var $zoho=$zoho || {};$zoho.salesiq = $zoho.salesiq ||
                {widgetcode:"86484f3b89c87a2e65e6ac98a0e5392b0a99a0a64abb15b39b89c6fc1eaab22a6ac934907bceb85a967a438292b23d18", values:{},ready:function(){}};
                var d=document;s=d.createElement("script");s.type="text/javascript";s.id="zsiqscript";s.defer=true;
                s.src="https://salesiq.zoho.com/widget";t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t);
                </script>`,
            },
            b2cGuestToken: 'Bearer eyJsb25ndGVybSI6dHJ1ZSwiYWxnIjoiSFM1MTIifQ.eyJzdWIiOiJ7XCJpZFwiOjYxMjMsXCJuYW1lXCI6XCJHdWVzdFwiLFwiZW1haWxcIjpcImd1ZXN0QGdtYWlsLmNvbVwiLFwibW9iaWxlXCI6XCI5OTk5OTk5OTkwXCIsXCJyb2xlXCI6XCJHVUVTVFwiLFwidXNlcklkXCI6XCI5OTk5OVwiLFwicGFydG5lcklkXCI6XCIwXCIsXCJzdGF0dXNcIjpcIkVOQUJMRURcIixcInByb2Nlc3NlZE9uXCI6XCIyMDIxLTA2LTAxVDE0OjIxOjMyLjAyOFwiLFwiY29udGFjdFBlcnNvbkluZm9cIjp7fSxcImFkZGl0aW9uYWxJbmZvXCI6e30sXCJjYW5CZUVtdWxhdGVkXCI6ZmFsc2UsXCJ1c2VyQ29uZlwiOnt9fSIsImV4cCI6MTU5MzIzNzM5MTE3fQ.ioP0ODMTfPDHl1nSaW8qn8js3I0fBTRC61AfkKOJVwN__cRhQBTWjkUMXumlojS5yaLYamwGXwWg05vUf1YidQ',
        },
        showDepositCredit: false,
        enablePointsAndCoins: false,
        onloadPopupConfig: {
            showOnloadPopup: true,
            frequency: 86400,
            displayOnLogin: true
        },
        showAddToQuote: true,
        showPerNightPrice: true,
        editMarkup: true,
        searchByLocationFilter: true,
        holdAllowed: true,
        fetchTripAdvisor: true,
        defaultRatings: '3,4,5',
        defaultRoomInfo: {
            numberOfAdults: 1,
            numberOfChild: 0,
            childAge: []
        },
        defaultDate: {
            startDate: 1,
            endDate: 2,
        },

        autoFillPaxMobile: false,
        autoFillPaxEmail: true,
        highlightBookingNotes: false,
        salesConfirmationMail: {
            'TJLOCAL': []
        },
        allConfirmationMail: [],
        cacheTimer: {
            offersNotificationCaching: 600,
            menubarCaching: 0,
            footerCaching: 0,
            leftnavCaching: 0,
        },
        dynamicBookingNotes: [],
        sendConfirmationToMappedSalesUser: false,
        travellerNameUnique: ['EXPEDIA'],
        noSpaceInFirstName: ['CLEARTRIP'],
        showRecentSearch: true,
        autoSuggestLengthLimit: 20,
        hotelExclusionList: [],
        panCardValidation: false,
        panCardMatchPercetage: 70,
        panCardValidationStatus: [200, 422],
        verificationByPassRoles: ['ADMIN'],
        mealPlanFilterPDP: {
            showFilter: false,
            removeExtraHeaders: false,
            mealBasisHeaders: ['Room Only', 'Breakfast', 'Half Board', 'Full Board'],
            mealBasisMapping: {}
        },
        showUnica: false,
        imageConfigSearchPage: ['EXPEDIA', 'HOTELBEDS'],
        loadAllPolicyPDP: false,
        cleanSearchResult: false,
        initialRoomView: false,
        groupOptionsVisible: 1,
        showSwitch: false,
        customPagination: {
            hotelImages: 12,
            roomImages: 6,
            roomImagesMobile: 3
        },
        roomAdditionalInfo: false,
        applyRoleConfig: false,
        applyGroupConfig: false,
        roleBasedConfig: {},
        groupBasedConfig: {},
        scripts: {
            zoho: '<script src="https://cdn.pagesense.io/js/tripmaza/63a7ee4aece94bbfb9c10002555032cd.js"></script>',
        },
        setCitySort: false,
        stickyFormLinks: {},
        splitStayCities: [],
        hotelSearchSize: 20,
        showRecentBooking: false,
        recentBookingDateRange: 7,
        trackingId: '',
        setCityEnabled: false,
        showMultiCity: false,
        unicaExclusionList: [],
        showOnRequestBookingPopup: false,
        analyticsEventEnable: false,
        emailPassport: false,
        enableCorporateBooking: false,
        enableSamePanPerBooking: false,
        showCheapestRoomOptions: false,
        showAddToFavourite: false,
        showTJVerified: false,
        showTrustYouReviews: false,
        searchByLocationDistance: {
            subRegionradius: 5,
            centerDistance: 10,
            enableSearchByLocation: false
        },
        CancellationPolicyAlert: false,
        roomMappingExclusions: [
            {
                cities: ['MALDIVES'],
                supplierIds: ['TJLOCAL']
            }
        ],
        paymentV2: [],
        dateCountryPopupData: {},
        showShareBy: false,
        searchByHotelName: [],
        incentivesBanner: {
            visible: false,
            data: [
                {
                    id: 1,
                    imgUrl: 'https://static.tripjack.com/banners/e5c51525-63ed-4606-8f40-a66e3a8cfd4b.jpg',
                    redirectUrl: 'https://tripjack.lpages.co/resorts-world-cruises/'
                },
            ]
        },
        emailIdsConfigs: {
            tcsEmailIds: ""
        },
        showRoomConsent: false
    };

module.exports = Config;
